import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import OrderLogin from './views/OrderLogin.vue';
import OrderAuthVerify from './views/OrderAuthVerify.vue';
import SpecialOffer from './views/SpecialOffer.vue';
import BrokerOrders from './views/BrokerOrders.vue';
import Instruments from './views/Instruments.vue';
import Questionnaire from './views/Questionnaire.vue';
import CustomerFullInfo from './views/CustomerFullInfo.vue';
import OrderDetail from './views/OrderDetail.vue';
import BrokerOrder from './views/BrokerOrder.vue';
import NotFound from './components/404.vue';
import PrivacyPolicy from './views/PrivacyPolicy.vue';
import TermsConditions from './views/TermsConditions.vue';
import Resellers from './views/Resellers.vue';
import ShowOffers from './views/ShowOffers.vue';
import ScalapayResult from './views/ScalapayResult.vue';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },

    {
      path: '/special',
      name: 'specialOffer',
      component: SpecialOffer
    },

    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicy
    },
    {
      path: '/terms-and-conditions',
      name: 'terms-and-conditions',
      component: TermsConditions
    },

    {
      // 1 step
      path: '/instruments',
      name: 'instruments',
      component: Instruments
      // meta: { isBroker: true }
    },
    {
      // 2 step
      path: '/questionnaire',
      name: 'questionnaire',
      component: Questionnaire
      // meta: { isBroker: true }
    },
    {
      // 3 step
      path: '/offers',
      component: ShowOffers,
      name: 'offers'
      // meta: { isBroker: true }
    },
    {
      // 4 step
      path: '/customer-full-info',
      component: CustomerFullInfo,
      name: 'customer-full-info'
      // meta: { isWizard: true }
    },
    {
      path: '/order',
      component: OrderDetail,
      name: 'order'
    },
    {
      path: '/order-login',
      component: OrderLogin,
      name: 'order-login'
    },

    {
      path: '/auth-order',
      component: OrderAuthVerify,
      name: 'auth-order'
    },

    // Area Broker
    {
      path: '/broker-login',
      component: Login,
      name: 'broker-login',
      meta: { isBroker: true }
    },

    {
      path: '/broker-orders',
      component: BrokerOrders,
      name: 'broker-orders',
      meta: { isBroker: true }
      // beforeEnter: auth
    },

    {
      path: '/broker-order/:id',
      component: BrokerOrder,
      name: 'broker-order',
      meta: { isBroker: true }
      // beforeEnter: auth
    },

    {
      path: '/resellers',
      component: Resellers,
      name: 'resellers'
    },

    {
      path: '/scalapay-result',
      component: ScalapayResult,
      name: 'scalapay-result'
    },

    { path: '*', component: NotFound }
  ]
});

export default router;
